import { apiClient } from '../../client'

export interface OverviewHeroKpiMetric {
    current_month_pct?: number
    last_month_pct?: number
    current_month_units?: number
    last_month_units?: number
    variance_pct: number
}

export interface OverviewHeroKpisResponse {
    availability: OverviewHeroKpiMetric & { current_month_pct: number; last_month_pct: number }
    freshness: OverviewHeroKpiMetric & { current_month_units: number; last_month_units: number }
    sos: OverviewHeroKpiMetric & { current_month_pct: number; last_month_pct: number }
    rtv: OverviewHeroKpiMetric & { current_month_units: number; last_month_units: number }
    pog: OverviewHeroKpiMetric & { current_month_pct: number; last_month_pct: number }
    promo: OverviewHeroKpiMetric & { current_month_pct: number; last_month_pct: number }
}

export interface OverviewSummaryStripsData {
    total_stores: number
    total_skus: number
    covered_stores: number
    covered_sku: number
    availability_avg_pct: number
}

export interface OverviewDashTableRow {
    city: string
    store: string
    availability_curr_pct: number
    availability_var_pct: number
    sos_curr_pct: number
    sos_var_pct: number
    pog_curr_pct: number
    pog_var_pct: number
    fresh_curr_pcs: number
    fresh_var_pcs: number
    rtv_curr_pcs: number
    rtv_var_pcs: number
    promo_curr_pct: number
    promo_var_pct: number
    bda_curr_pct: number
    bda_var_pct: number
}

class OverviewRepository {
    async getHeroKpis(): Promise<OverviewHeroKpisResponse> {
        return apiClient.get<OverviewHeroKpisResponse>('/business-kpi-dashboards/overview/hero-kpis')
    }

    async getSummaryStrips(): Promise<OverviewSummaryStripsData> {
        return apiClient.get<OverviewSummaryStripsData>('/business-kpi-dashboards/overview/summary-strips')
    }

    async getDashTable(): Promise<OverviewDashTableRow[]> {
        return apiClient.get('/business-kpi-dashboards/overview/dash-table')
    }
}

export const overviewRepository = new OverviewRepository()
